import React from 'react';
import { createSvgIcon } from './createSvgIcon';
export const CameraIcon = createSvgIcon({
    displayName: 'Camera',
    path: (React.createElement("path", { d: "M32 16c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zM61 6H48.24L43.15.9A3 3 0 0 0 41 0H23a3 3 0 0 0-2.38 1.2L15.8 6H3a3 3 0 0 0-3 3v40a3 3 0 0 0 3 3h58a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3zM32 46c-9.94 0-18-8.06-18-18s8.06-18 18-18 18 8.06 18 18a18 18 0 0 1-18 18z" })),
    viewBox: '0 0 64 52',
});
